<file-manager [initialPath]="initialPath" [featureKey]="'FINANCE_FILE_MANAGER'"></file-manager>

